import { render, staticRenderFns } from "./GoodsProfitStatistics.vue?vue&type=template&id=da830bb4&scoped=true"
import script from "./GoodsProfitStatistics.vue?vue&type=script&lang=js"
export * from "./GoodsProfitStatistics.vue?vue&type=script&lang=js"
import style0 from "./GoodsProfitStatistics.vue?vue&type=style&index=0&id=da830bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da830bb4",
  null
  
)

export default component.exports